import React, { useState, useEffect } from 'react'

import useAuthToken from '../utils/api/use-auth-token'
import getCareteamAPI from '../api/routes/get-careteam'
import { NavBar } from '../components'

const Auth0Callback = () => {
  const { tokenPending, authToken } = useAuthToken()
  const [careteam, setCareteam] = useState(null as any)

  useEffect(() => {
    if (tokenPending || !authToken) {
      return
    }
    if (careteam !== null) {
      return
    }

    const fetchData = async () => {
      const response = await getCareteamAPI(authToken)
      setCareteam(response.responsePayload)
    }
    fetchData()
  })

  return (
    <div id="app" className="d-flex flex-column h-100">
      <NavBar />
      <div className="container flex-grow-1">
        <div className="row">
          <div className="col-12 p-4">Post Auth0 Authentication</div>
        </div>
        <div className="row">
          <div className="col-12 p-4">
            Token {tokenPending ? 'pending' : 'available'}
          </div>
        </div>
        <div className="row">
          <div className="col-12 p-4">GET CARETEAM:</div>
        </div>
        <div className="row">
          <pre className="col-12 text-light bg-dark p-4">
            {JSON.stringify(careteam, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  )
}

export default Auth0Callback
